/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import Button from "../button";
import { CONSENT_LIST, QUESTION_KEYS, QUESTION_TYPES, CIBIL_CASES, INITIAL_ANSWER_STATE } from "./constant";
import InputRadioButton from "../input-radio-button";
import InputMobile from "../input-mobile";
import { NUMBER } from "../../../constants/app-constants";
import CloseButton from "../icon-cross";
import ShieldDone from "./images/shield-done.svg";
import PostInspectionDiyVideoSteps from "../post-inspection-diy-video-steps";
import AcceptTick from "./images/accept-tick.svg";
import { mobileNumberValidator } from "./selector";
import { sendCustomGaEvents } from "../../../tracking";
import isObjectEmpty from "../../../utils/helpers/isObjectEmpty";

const PostInspectionDiyQuestions = ({
    questionList,
    isLoading,
    onConfirmation,
    closeHandler,
    setQuestionList = () => {},
    encryptedMobileNumber = "",
    allowClosePopup = true,
    showCibilQuestions,
    helperVideos = [],
    appointmentId
}) => {
    const inputRef = useRef(null);
    const [selectedQuestion, setSelectedQuestion] = useState(NUMBER.ZERO);
    const [mobile, setMobile] = useState("");
    const [answers, setAnswers] = useState(INITIAL_ANSWER_STATE);
    const [showQuestions, setShowQuestions] = useState(showCibilQuestions);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (showCibilQuestions) setShowQuestions(true);
    }, [showCibilQuestions]);

    const callGaHandler = (details) => {
        sendCustomGaEvents({
            eventLabel: appointmentId,
            ...details
        });
    };

    const onOptionSelect = (option) => {
        setAnswers((answer) => {
            return { ...answer, [questionList[selectedQuestion].key]: option.key };
        });
    };

    const confirmQuestionReponses = () => {
        if (answers) {
            onConfirmation({
                source: "MWEB",
                questionnaireResponse: {
                    ...(answers[QUESTION_KEYS.OWNERSHIP] && { [QUESTION_KEYS.OWNERSHIP]: answers[QUESTION_KEYS.OWNERSHIP] }),
                    ...(answers[QUESTION_KEYS.LOAN] && { [QUESTION_KEYS.LOAN]: answers[QUESTION_KEYS.LOAN] })
                }
            });
        }
    };

    const handleNextStep = (isCibil = false) => {
        if (selectedQuestion === questionList.length - NUMBER.ONE) {
            if (isCibil) setQuestionList([]);
            else confirmQuestionReponses();
        } else {
            setSelectedQuestion(index => index + NUMBER.ONE);
        }
    };

    const handleConfirm = (question) => {
        if (CIBIL_CASES.includes(question.key)) {
            onConfirmation(question, mobile);
        } else handleNextStep();
    };

    const checkIfSelected  = () => {
        const key = questionList[selectedQuestion].key;
        return !!answers[key] || mobileNumberValidator(mobile, encryptedMobileNumber);
    };

    const mobileChangeHandler = (e) => {
        const isValid = mobileNumberValidator(e.target.value, encryptedMobileNumber);
        setIsError(!isValid);
        setMobile(e.target.value);
    };

    const renderOptions = (question) => {
        if (question.type === QUESTION_TYPES.INPUT) {
            return (
                <InputMobile
                    inputRef={inputRef}
                    value={mobile}
                    placeholder={"Phone number"}
                    onChange={(e) => mobileChangeHandler(e)}
                    showError={false}
                />
            );
        }
        return (
            <ul>
                {
                    (question.options || []).map((option, index) => (
                        <li key={`options-${index}`}>
                            <InputRadioButton
                                id = {option.key}
                                text ={option.displayText}
                                onClick={() => {onOptionSelect(option);}}
                            />
                        </li>
                    ))
                }
            </ul>
        );
    };

    const renderModalHeader = (question) => {
        if (question.key === QUESTION_KEYS.CIBIL) return <h3>Update latest number linked with car loan</h3>;
        if (question.key === QUESTION_KEYS.CONSENT) return <h3>Give consent for credit report check</h3>;
        return <h3>Help us know better!</h3>;
    };

    const handleShowQuestions = () => {
        setShowQuestions(true);
    };

    useEffect(() => {
        if (!helperVideos || !helperVideos.length) handleShowQuestions();
        const { gaEvent = {} } = questionList[selectedQuestion] || {};
        if (appointmentId && !isObjectEmpty(gaEvent)) {
            callGaHandler(gaEvent);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (showQuestions) {
        return (
            <div styleName={`styles.questionPopupWrapper`}>
                <div styleName={`styles.questionPopup ${showCibilQuestions ? "styles.cibilWrapper" : ""}`}>
                    {
                        questionList.map((question, index) => (
                            selectedQuestion === index ?
                                <>
                                    <div styleName={"styles.modalHeader"}>
                                        {renderModalHeader(question)}
                                        {allowClosePopup && <CloseButton type={"black"} onClickHandler={() => {closeHandler(question);}} />}
                                    </div>
                                    <div key={`question-${index}`} styleName={"styles.questionWrapper"}>
                                        {question.title && <h4>{question.title}</h4>}
                                        {
                                            question.key === QUESTION_KEYS.CIBIL &&
                                        <p styleName={"styles.text"}>This will help us in credit report generation & <br/> validation of your car loan</p>
                                        }
                                        {
                                            question.key === QUESTION_KEYS.CONSENT &&
                                            <div styleName={"styles.creditReportText"}>
                                                <p>Helps in validating your car loan details and obtaining a NOC <b>(no objection certificate)</b> from your Bank/NBFC, essential for RC transfer</p>
                                                <div styleName={"styles.listWrapper"}>
                                                    {CONSENT_LIST.map((item, idx) => (<span styleName={"styles.list"} key={`consent-${idx}`}>
                                                        <img src={ShieldDone} alt="shield done" />
                                                        {item}
                                                    </span>))}
                                                </div>
                                            </div>
                                        }
                                        {renderOptions(question)}
                                        {
                                            question.key === QUESTION_KEYS.CIBIL &&
                                        <p styleName={`styles.infoText ${isError ? "styles.error" : ""}`}>Enter your phone number ending with {encryptedMobileNumber}</p>
                                        }
                                    </div>
                                    <div styleName={showCibilQuestions ? "styles.cibilCtaWrapper" : ""}>
                                        <Button
                                            text={question.ctaLabel}
                                            isLoading={isLoading}
                                            disabled={!checkIfSelected()}
                                            onClick={() => {handleConfirm(question);}}
                                        />
                                    </div>
                                </> : null
                        ))
                    }
                </div>
            </div>
        );
    }

    return (
        <div styleName={"styles.priceWrapper"}>
            <img src={AcceptTick} alt="tick" styleName={"styles.acceptTick"}/>
            <h3>PRICE ACCEPTED</h3>
            <p>Now, to close the deal you  <br/>need to complete these steps</p>
            <PostInspectionDiyVideoSteps />
            <Button
                text={"OK! GOT IT"}
                onClick={handleShowQuestions}
            />
        </div>
    );

};

PostInspectionDiyQuestions.propTypes = {
    questionList: PropTypes.array,
    isLoading: PropTypes.bool,
    onConfirmation: PropTypes.func,
    closeHandler: PropTypes.func,
    setQuestionList: PropTypes.func,
    encryptedMobileNumber: PropTypes.any,
    allowClosePopup: PropTypes.bool,
    showCibilQuestions: PropTypes.bool,
    helperVideos: PropTypes.array,
    appointmentId: PropTypes.string
};

export default PostInspectionDiyQuestions;
